import { Model, ModelClass } from './Model';

export interface TransactionType extends ModelClass {}

export const Transaction: TransactionType = Model('Transaction', {
    endpoint: 'apparel-transactions',
})`
    id:Int;
    created_at:DateTime;
    updated_at:DateTime;
    factory_id:Int;
    customer_id:Int;
    subtotal:String;
    total:String;
    tax:String;
    comencement_date:DateTime;
    expected_delivery_date:DateTime;
    completion_time_estimate:DateTime;
    completion_time:DateTime;
    status:String;
    stage_statuses:Any;
    current_stage:Any;
`;
